export enum ContactHandlerKeys {
  PHONE = 'phone',
  EMAIL = 'email',
  ROOM = 'room',
  SKYPE = 'skype',
  TELEGRAM = 'telegram',
  INSTAGRAM = 'instagram',
  VK = 'vk',
  GITHUB = 'github',
  TWITTER = 'twitter',
  BITBUCKET = 'bitBucket',
  FACEBOOK = 'facebook',
}

export enum AnswersStatus {
  NEW = 'new',
  SENT = 'sent',
  EDITED = 'edited',
  DELAYED = 'delayed',
  EXPIRED = 'expired',
}
export enum AnswersOrder {
  USER_ACS = 'user',
  USER_DESC = '-user',
  CREATED_AT_ASC = 'createdAt',
  CREATED_AT_DESC = '-createdAt',
  HR_ASC = 'hr',
  HR_DESC = '-hr',
  EDITED_BY_ASC = 'editedBy',
  EDITED_BY_DESC = '-editedBy',
  TYPE_ASC = 'type',
  TYPE_DESC = '-type',
}
